export const ServiceUrl = {
  LIST_SETTINGS: "v1/set/list",
  LOGIN: "v1/login/check",
  SETTINGS: {
    MODULES: {
      LIST: "v1/admin/settings/modules/list",
      SAVE: "v1/admin/settings/modules/save",
      DELETE: "v1/admin/settings/modules/delete",
      UPDATE: "v1/admin/settings/modules/update",
    },
    USER_LOGINS: {
      LIST: "v1/admin/settings/userlogin/list",
      SAVE: "v1/admin/settings/userlogin/save",
      DELETE: "v1/admin/settings/userlogin/delete",
      UPDATE_STATUS: "v1/admin/settings/userlogin/update-status",
      UPDATE: "v1/admin/settings/userlogin/update",
      UPDATE_PASSWORD: "v1/admin/settings/userlogin/update-password",

      VIEW_USER_LOGIN_PASSWORD:
        "v1/admin/settings/userlogin/view-user-password",
    },
    RBAC: {
      USER_ROLES: {
        SAVE: "v1/admin/rbac/userrole/save",
        LIST: "v1/admin/rbac/userrole/list",
        DELETE: "v1/admin/rbac/userrole/delete",
        STATUS_UPDATE: "v1/admin/rbac/userrole/status-update",
        UPDATE: "v1/admin/rbac/userrole/update",
      },
      ROLE_AND_ACCESS: {
        UPDATE_ROLE_AND_ACCESS: "v1/admin/rbac/roleaccess/update-role-access",
        LIST_ROLE_AND_PERMISSIONS:
          "v1/admin/rbac/roleaccess/list-role-permissions",
      },
    },
    AGENCIES: {
      LIST: "v1/admin/settings/agencies/list",
      SAVE: "v1/admin/settings/agencies/save",
      STATUS_UPDATE: "v1/admin/settings/agencies/status-update",
      DELETE: "v1/admin/settings/agencies/delete",
      UPDATE: "v1/admin/settings/agencies/update",
      UPDATE_BANK: "v1/admin/settings/agencies/update-bank",
      UPDATE_SMSMAIL: "v1/admin/settings/agencies/update-smsmail",
      UPDATE_WHITE_LABEL: "v1/admin/settings/agencies/update-white-label",
      STATE_LIST: "v1/admin/settings/state/list",
    },
  },
  SCHOOLS: {
    SCHOOL: {
      LIST: "v1/admin/schools/school/list",
      DELETE: "v1/admin/schools/school/delete",
      UPDATE_STATUS: "v1/admin/schools/school/status-update",
      UPDATE: "v1/admin/schools/school/update",
      SAVE: "v1/admin/schools/school/save",

      //LIST_STATISTICS: "v1/admin/schools/school/list-statistics",
      LIST_TRANSACTION: "v1/admin/schools/school/list-transaction",
    },
  },
  DASHBOARD: {
    FIRST_LINE_COUNT: "v1/admin/dashboard/first-line-counts",
  },
};
